import { CirclePlus } from "lucide-react";
import { Button } from "./Button";
import { forwardRef } from "react";

const CreateButtonTrigger = forwardRef((props, ref) => {
  return (
    <Button {...props} className="h-7 gap-1" ref={ref}>
      <span className="sr-only sm:not-sr-only sm:whitespace-nowrap">Crear</span>
      <CirclePlus className="sm:hidden" />
    </Button>
  );
});

export default CreateButtonTrigger;
